<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>融资管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/credit/list' }">
        <span>授信管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>授信申请详情</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 企业信息 -->
    <div class="segment-outer">
      <div class="segment">
        <div class="segment-header">企业信息</div>
        <div class="mt-20 segment-area">
          <div class="segment-item">
            <div class="tit">企业名称：</div>
            <div class="bor">{{ detailData.companyName }}</div>
          </div>
          <div class="segment-item">
            <div class="tit">统一社会信用代码：</div>
            <div class="bor">{{ detailData.companyCreditCode }}</div>
          </div>
          <div class="segment-item">
            <div class="tit">法人姓名：</div>
            <div class="bor">{{ detailData.companyCreditMan }}</div>
          </div>
          <div class="segment-item">
            <div class="tit">法人身份证号码：</div>
            <div class="bor">{{ detailData.companyCreditManIdCode }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 所选融资产品 -->
    <div class="segment-outer">
      <div class="segment">
        <div class="segment-header">所选融资产品</div>
        <div class="mt-20 segment-area">
          <div>
            <div class="product-name">{{ detailData.productName }}</div>
            <div class="product-company">
              <div class="company-tag">资金方</div>
              {{ detailData.fundSideName }}
            </div>
            <div class="cl mt-15">
              <div class="product-tip mr-8">
                <div class="tip-name">
                  <img class="tip-icon" src="../../assets/img/finance/product_detail_percent_icon.png" />年化利率
                </div>
                <div class="cl">
                  <span class="tip-value">{{ detailData.annualInterestRate }}<span class="tip-unit">%</span></span>
                </div>
              </div>
              <div class="product-tip mr-8">
                <div class="tip-name">
                  <img class="tip-icon" src="../../assets/img/finance/product_detail_time_icon.png" />融资期限
                </div>
                <div class="cl">
                  <span>
                    <span v-for="(el, idx) in detailData.productDeadlineList" class="tip-value"
                      >{{ el }}<span class="tip-unit">天</span>
                      <span v-if="idx < detailData.productDeadlineList?.length - 1" class="tip-unit"> / </span></span
                    >
                  </span>
                </div>
              </div>
              <div class="product-tip">
                <div class="tip-name">
                  <img class="tip-icon" src="../../assets/img/finance/product_detail_amount_icon.png" />还款方式
                </div>
                <div class="cl">
                  <div class="tip-tag">{{ detailData.repaymentTypeDesc }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 上传附件 -->
    <div class="segment-outer">
      <div class="segment">
        <div class="segment-header">上传附件</div>
        <div class="mt-20 segment-area">
          <div>
            <FeFilePreview
              :imageList="(detailData.fileList || []).map(el => el.fileUrl)"
              :multiple="false"
            ></FeFilePreview>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-20 ml-20">
      <el-button @click="cancel" id="auto-8">返回</el-button>
    </div>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:8
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import FeFilePreview from '@/components/FeFilePreview';
import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';
export default {
  components: { FeFilePreview },
  data() {
    return {
      detailData: {
        applicationNo: '', // 授信编号
        companyName: '', // 企业名字
        companyCreditCode: '', // 企业社会信用编码
        companyCreditMan: '', // 企业法人
        companyCreditManIdCode: '', // 企业法人身份证号
        platformProductId: '', // 产品id
        productName: '', // 产品名称
        fundSideName: '', // 资金方名称
        annualInterestRate: '', // 年化利率
        productDeadlineList: [], // 融资期限
        repaymentType: '', // 还款方式
        repaymentTypeDesc: '', // 还款方式描述
        fileList: [] // 文件列表
      }
    };
  },
  created() {
    this.fetchDetail();
  },
  methods: {
    async fetchDetail() {
      const res = await axios.post(api.creditApplyDetail, { applicationNo: this.$route.params.applicationNo });
      this.detailData = res.data || {};
    },
    cancel() {
      this.$router.push(`/credit/list`);
    }
  }
};
</script>

<style lang="postcss" scoped>
.mr-8 {
  margin-right: 8px;
}
.segment-item {
  width: 50%;
  display: inline-flex;
  margin-bottom: 16px;
  box-sizing: border-box;
  padding-right: 20px;
  .tit {
    flex: 0 0 auto;
  }
  .bor {
    flex: 1 1 auto;
  }
}
.product-name {
  padding-top: 5px;
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  line-height: 28px;
  margin-bottom: 8px;
}
.company-tag {
  display: inline-block;
  width: 44px;
  height: 18px;
  background-image: linear-gradient(to right, #f7d38f, #ffefc9);
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  color: #a2643e;
  line-height: 18px;
}
.product-tip {
  float: left;
  background: #fafcfe;
  border-radius: 8px;
  width: 260px;
  height: 64px;
  box-sizing: border-box;
  padding: 10px 24px 10px 16px;
  .tip-name {
    font-size: 12px;
    font-weight: 400;
    color: #333333;
    line-height: 17px;
    margin-bottom: 7px;
  }
  .tip-value {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    line-height: 24px;
    .tip-unit {
      font-size: 12px;
    }
  }
  .tip-tag {
    display: inline-block;
    background: #e9f5ff;
    border-radius: 2px;
    font-size: 12px;
    font-weight: 400;
    color: #3399ff;
    line-height: 20px;
    text-align: center;
    padding: 0 6px;
    vertical-align: bottom;
  }
  .tip-icon {
    width: 16px;
    height: 16px;
    margin-right: 4px;
    transform: translateY(-2px);
  }
}
</style>
